import React, { Component } from 'react';
import styles from '../../pages/privacy.module.scss';
import imgAppIcon from '../../pages/images/img-appicon-large.png';

export default class Privacy extends Component {
  render() {
    return (
      <article className={styles.pageContainer}>
        <section className={styles.postBody}>
          <header className={styles.header}>
            <img src={imgAppIcon} className={styles.appIcon} />

            <h1>Privacy Policy</h1>
          </header>

          <p>This Privacy Policy governs the manner in which 前端找工作 collects, uses, maintains and discloses information collected from users (each, a "User") of the 前端找工作 app ("App").</p>

          <h3>Personal identification information</h3>
          <p>We may collect personal identification information from Users in a variety of ways in connection with activities, services, features or resources we make available on our App. Users may visit our App anonymously. We will collect personal identification information from Users only if they voluntarily submit such information to us. Users can always refuse to supply personally identification information, except that it may prevent them from engaging in certain App related activities.</p>

          <h3>Non-personal identification information</h3>
          <p>We may collect non-personal identification information about Users whenever they interact with our App. Non-personal identification information may include the browser name, the type of computer and technical information about Users means of connection to our App, such as the operating system and the Internet service providers utilized and other similar information.</p>

          <h3>Web browser cookies</h3>
          <p>Our App may use "cookies" to enhance User experience. User's web browser places cookies on their hard drive for record-keeping purposes and sometimes to track information about them. User may choose to set their web browser to refuse cookies, or to alert you when cookies are being sent. If they do so, note that some parts of the App may not function properly.</p>

          <h3>How we use collected information</h3>
          <p>前端找工作 may collect and use Users personal information for the following purposes:</p>
          <ul>
            <li>
              <i>To run and operate our App</i><br />
              We may need your information display content on the App correctly.
            </li>
          </ul>

          <h3>How we protect your information</h3>
          <p>We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized access, alteration, disclosure or destruction of your personal information, username, password, transaction information and data stored on our App.</p>

          <h3>Sharing your personal information</h3>
          <p>We do not sell, trade, or rent Users personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information regarding visitors and users with our business partners, trusted affiliates and advertisers for the purposes outlined above. </p>

          <p>We may share or sell information with third parties for marketing or other purposes.</p>

          <h3>Sharing your personal information</h3>
          <p>This Privacy Policy governs the manner in which 前端找工作 collects, uses, maintains and discloses information collected from users (each, a "User") of the 前端找工作 app ("App").</p>

          <h3>Personal identification information</h3>
          <p>We may collect personal identification information from Users in a variety of ways in connection with activities, services, features or resources we make available on our App. Users may visit our App anonymously. We will collect personal identification information from Users only if they voluntarily submit such information to us. Users can always refuse to supply personally identification information, except that it may prevent them from engaging in certain App related activities.</p>

          <h3>Non-personal identification information</h3>
          <p>We may collect non-personal identification information about Users whenever they interact with our App. Non-personal identification information may include the browser name, the type of computer and technical information about Users means of connection to our App, such as the operating system and the Internet service providers utilized and other similar information.</p>

          <h3>Web browser cookies</h3>
          <p>Our App may use "cookies" to enhance User experience. User's web browser places cookies on their hard drive for record-keeping purposes and sometimes to track information about them. User may choose to set their web browser to refuse cookies, or to alert you when cookies are being sent. If they do so, note that some parts of the App may not function properly.</p>

          <h3>How we use collected information</h3>
          <p>前端找工作 may collect and use Users personal information for the following purposes:</p>
          <ul>
            <li>
              <i>To run and operate our App</i><br />
              We may need your information display content on the App correctly.
            </li>
          </ul>

          <h3>How we protect your information</h3>
          <p>We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized access, alteration, disclosure or destruction of your personal information, username, password, transaction information and data stored on our App.</p>

          <h3>Sharing your personal information</h3>
          <p>We do not sell, trade, or rent Users personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information regarding visitors and users with our business partners, trusted affiliates and advertisers for the purposes outlined above. </p>

          <p>We may share or sell information with third parties for marketing or other purposes.</p>

          <h3>Changes to this privacy policy</h3>
          <p>前端找工作 has the discretion to update this privacy policy at any time. When we do, we will post a notification on the main page of our App. We encourage Users to frequently check this page for any changes to stay informed about how we are helping to protect the personal information we collect. You acknowledge and agree that it is your responsibility to review this privacy policy periodically and become aware of modifications.</p>

          <h3>Your acceptance of these terms</h3>
          <p>By using this App, you signify your acceptance of this policy. If you do not agree to this policy, please do not use our App. Your continued use of the App following the posting of changes to this policy will be deemed your acceptance of those changes.</p>

          <h3>Contacting us</h3>
          <p>If you have any questions about this Privacy Policy, the practices of this site, or your dealings with this site, please contact us.</p>

          <p>This document was last updated on Nov 23, 2018</p><p>Generated by <a href="https://privacypolicies.com">PrivacyPolicies.com</a></p>

          <hr />

          <header className={styles.header}>
            <img src={imgAppIcon} className={styles.appIcon} />

            <h1>服務條款與免責聲明</h1>
          </header>

          <p></p>

          <p>
            1. 「前端找工作」App
            針對網站公開職缺資訊作陳列索引，是一提供求職者快速查閱職缺資料的工具。
          </p>

          <p>
            2. 「前端找工作」App 顯示的職缺與評論資訊皆非「前端找工作」App
            所有。
            任何相關權利包括但不限於專利權、商標權、著作權等皆為原提供實體所有，因此任何因資料錯誤所造成之損害皆與本
            App 無關。
          </p>

          <p>
            3. 「前端找工作」App
            內顯示的求職網站商標與頁面，僅用於標示職缺來源之合理使用，並不表示該網站與本
            App 有合作關係。
          </p>

          <p>
            4. 「前端找工作」App
            內工作評論資訊皆來自「求職天眼通」（<a href="https://www.qollie.com/" target="_blank">https://www.qollie.com/</a>）網站與
            API，「前端找工作」 App 對其內容之真實性或完整性不負有任何責任。
          </p>

          <p>
            5. 「前端找工作」App
            保留任何時候修改上述條款的權利，條款最新內容請以最新版 App 為準。
          </p>

          <p>
            6. 若您開始使用本 App，表示您對上述條款與聲明已經清楚且了解。
          </p>
        </section>
      </article>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Privacy/zhTW.js